<style>
    .c-table .img-avatar.rounded {
        border-radius: 50%;
    }

</style>

<template>
    <div class="c-table">
        <table v-if="dataColumns.length > 0" :class="{ 'table-responsive': Core.Display.isMobile(), 'table-striped' : options.striped || options.striped === undefined }" class="table">
            <thead v-if="dataColumns.length > 0 && (options.header || options.header === undefined)">
                <th :key="'h' + column.key" @click="columnClick(column, columnIndex)" v-for="column, columnIndex  in dataColumns">{{column.label}}</th>
            </thead>
            <tbody>
                <tr :id="'row' + row.id" :key="'row' + rowIndex" @click="rowClick(row, rowIndex)" v-for="row, rowIndex in dataRows">
                    <td :key="'col' + columnIndex" :class="column.classes" :style="column.styles" v-for="column, columnIndex in dataColumns">
                        <span v-if="row[column.key] && row[column.key].value !== undefined" @click="cellClick(dataRows[rowIndex][column.key].value, dataRows[rowIndex][column.key], row, rowIndex, columnIndex)"  v-html="dataRows[rowIndex][column.key].value"></span>
                        <span v-else-if="row['Readable_' + column.key] !== undefined" v-html="row['Readable_' + column.key]"></span>
                        <span v-else v-html="row[column.key]"></span>
                    </td>
                </tr>
                <tr v-if="dataRows.length == 0">
                    <td :colspan="columns.length">{{options.emptyText}}</td>
                </tr>
            </tbody>
        </table>
        <b-pagination @change="change" v-if="options.pagination" :total-rows="pagination.totalRows" :per-page="pagination.perPage" v-model="pagination.page" :prev-text="pagination.prevText" :next-text="pagination.nextText"/>
    </div>
</template>

<script>
    export default {
        name: 'Table',
        components: {
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        emptyText: '',
                        pagination: true,
                        header: true,
                        striped: true
                    }
                }
            },
            columns: {
                type: Array,
                required: true,
                default: function() {
                    return []
                }
            },
            rows: {
                type: Array,
                required: true,
                default: function() {
                    return []
                }
            },
            pagination: {
                type: Object,
                default: function() {
                    return {
                        totalRows: 0,
                        perPage: 10,
                        page: 1,
                        prevText: '',
                        nextText: ''
                    }
                }
            },
            onRowClick: {
                type: Function,
                default: function(row, index) {
                    return false
                }
            },
            onColumnClick: {
                type: Function,
                default: function(column, index) {
                    return false
                }
            },
            onCellClick: {
                type: Function,
                default: function(value, cell, row, rowIndex, columnIndex) {
                    return false
                }
            },
            onPageClick: {
                type: Function,
                default: function(page) {
                    return false
                }
            },
            selectOptions: {
                type: Object | Array,
                default: function() {
                    return {}
                }
            }
        },
        watch: {
            rows: {
                handler(val) {
                    this.dataRows = val
                    this.setReadables()
                },
                deep: true
            },
            columns: {
                handler(val) {
                    this.dataColumns = val
                },
                deep: true
            }
        },
        mounted() {
            this.dataColumns = this.columns
            this.dataRows = this.rows
            this.setReadables()
        },
        data: () => {
            return {
                Core: window.Core,
                dataSelectOptions: [],
                dataColumns: [],
                dataRows: []
            }
        },
        methods: {
            setReadables() {
                for(let rowIndex in this.dataRows) {
                    for(let colIndex in this.dataColumns) {
                        let column = this.dataColumns[colIndex]
                        let row = this.dataRows[rowIndex]
                        if (column.key !== undefined) {
                            let value = row[column.key]
                            if (row['Readable_' + column.key] === undefined) {
                                if (Core.Validation.isEmpty(value)&&column.type !== Core.Value.typeAvatar) {
                                        row['Readable_' + column.key] = '-'
                                } else {
                                    switch (column.type) {
                                        case Core.Value.typeAvatar:
                                            let width = ''
                                            if (column.width !== undefined) {
                                                width = 'width:' + column.width
                                            }
                                            let avatar = Core.User.displayAvatar(value, column.defaultAvatar)
                                            if (avatar) {
                                                row['Readable_' + column.key] = "<img style='" + width + "' src='" + avatar + "' />"
                                            } else {
                                                row['Readable_' + column.key] = ''
                                            }
                                            break
                                        case Core.Value.typeSelect:
                                            if (this.selectOptions[column.key] !== undefined) {
                                                row['Readable_' + column.key] = Core.Select.label(value, this.selectOptions[column.key])
                                            }
                                            break
                                        case Core.Value.typeCurrency:
                                            row['Readable_' + column.key] = Core.Currency.format(value)
                                            break
                                        case Core.Value.typeDate:
                                            let format = 'DD MMM YYYY'
                                            if (column.format !== undefined) {
                                                format = column.format
                                            }
                                            row['Readable_' + column.key] = Core.Date.format(value, format)
                                            break
                                        case Core.Value.typeDateTime:
                                            let dateTimeFormat = 'DD MMM YYYY hh:mm'
                                            if (column.format !== undefined) {
                                                dateTimeFormat = column.format
                                            }
                                            row['Readable_' + column.key] = Core.Date.format(value, dateTimeFormat)
                                            break
                                        case Core.Value.typeCheckbox:

                                            if (value === '1' || value === 'true' || value === true) {
                                                row['Readable_' + column.key] = Core.Definition.getDefinition('Oui')
                                            }

                                            if (value === '0' || value === 'false' || value === false) {
                                                row['Readable_' + column.key] = Core.Definition.getDefinition('Non')
                                            }

                                            break
                                        default:
                                            row['Readable_' + column.key] = value
                                            break
                                    }
                                }
                            }
                        }
                        this.dataRows[rowIndex] = row
                    }
                }
            },
            columnClick(column, index) {
                this.onColumnClick(column, index)
            },
            rowClick(row, index) {
                this.onRowClick(row, index)
            },
            cellClick(value, cell, row, rowIndex, columnIndex) {
                if (cell.callBack !== undefined) {
                    cell.callBack(value, cell, row, rowIndex, columnIndex, this)
                }
                this.onCellClick(value, cell, row, rowIndex, columnIndex, this)
            },
            change(page) {
                this.onPageClick(page)
            }
        }
    }
</script>
